import { render } from "./DiscrepanciesFoundCard.vue?vue&type=template&id=0b94276c"
import script from "./DiscrepanciesFoundCard.vue?vue&type=script&lang=js"
export * from "./DiscrepanciesFoundCard.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Epaylater Projects\\microapp-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__